import { mdiContentCopy } from '@mdi/js'

import {
  HomeUIDWrapper,
  HomeUIDCopy,
  HomeUIDIcon,
  HomeUIDButton,
} from './styles'
import { StyledLabel, StyledTitle } from '../styles'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { mainInfoHomeUID } from '../messages'

interface HomeUIDProps {
  uid: string
}

function HomeUID({ uid }: HomeUIDProps) {
  const { formatMessage } = useIntl()
  const [copied, setCopied] = useState(false)

  const handleClick = async () => {
    await navigator.clipboard.writeText(uid)
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  if (!uid) {
    return null
  }

  return (
    <HomeUIDWrapper>
      <StyledLabel>{formatMessage(mainInfoHomeUID.homeUID)}</StyledLabel>
      <HomeUIDCopy>
        <StyledTitle>
          {copied ? formatMessage(mainInfoHomeUID.copied) : uid}
        </StyledTitle>
        <HomeUIDButton
          onClick={handleClick}
          title={formatMessage(mainInfoHomeUID.copy)}
        >
          <HomeUIDIcon path={mdiContentCopy} size={1} />
        </HomeUIDButton>
      </HomeUIDCopy>
    </HomeUIDWrapper>
  )
}

export default HomeUID
